import { styled } from '@mui/material/styles';

const StyledSysAidLogo = styled('img')`
  padding: ${(props) => (props?.expanded ? '10px 80px' : '10px 8px')};
  position: absolute;
  bottom: 2px;
  background-color: white;
`;

export default StyledSysAidLogo;
